import { useMemo, type ReactNode } from 'react'
import { Text, type TextProps } from '@mantine/core'

function escapeRegex(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

import { extractHighlightTerms } from '@/components/knowledge/search-utils'

export function extractSearchTerms(query: string): string[] {
  return extractHighlightTerms(query)
}

export function HighlightedSearchText({
  text,
  query,
  ...textProps
}: {
  text: string
  query: string
} & TextProps) {
  const content = useMemo(() => {
    if (!text) return null
    const terms = extractSearchTerms(query)
    if (terms.length === 0) return text

    const pattern = terms.map(escapeRegex).join('|')
    const re = new RegExp(`(${pattern})`, 'gi')
    const parts = text.split(re)
    const nodes: ReactNode[] = []

    for (let i = 0; i < parts.length; i++) {
      const part = parts[i]
      if (!part) continue
      if (i % 2 === 1) {
        nodes.push(
          <mark key={i} className="kb-search-highlight">
            {part}
          </mark>,
        )
      } else {
        nodes.push(part)
      }
    }

    return nodes.length > 0 ? nodes : text
  }, [text, query])

  return (
    <Text component="span" {...textProps}>
      {content}
    </Text>
  )
}
